import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  withRouter,
  Redirect,
} from 'react-router-dom';
import { formatRoute } from 'react-router-named-routes';

import {
  Grid,
  Paper,
  Typography,
} from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';

import * as routes from '../../config/routes';
import MainLayout from '../../common/components/MainLayout';
import Alert from '../../common/components/Alert';
import FormErrorDialog from '../../common/components/formErrorDialog';
import * as profileActions from '../actions';
import classes from '../../css/getCSS';
import * as constants from '../../config/constants';

import AccountInfoForm from '../components/AccountInfoForm';
import PersonalInfoForm from '../components/PersonalInfoForm';
import LifestyleInfoForm from '../components/LifestyleInfoForm';
import EducationInfoForm from '../components/EducationInfoForm';
import FamilyInfoForm from '../components/FamilyInfoForm';
import ContactInfoForm from '../components/ContactInfoForm';
import ReferenceInfoForm from '../components/ReferenceInfoForm';
import FileUploadForm from '../components/FileUploadForm';


class CompleteProfile extends Component {
  componentDidMount() {
    if (!this.props.user.is_complete) {
      const step = this.props.match.params.step;  // eslint-disable-line
      const section = constants.STEP_SECTIONS[step];
      this.props.getSectionData(
        section,
        this.props.token,
        this.props[section],
        this.props.history,
        this.props.siteId,
      );
    }
    window.scrollTo(0, 0);
    document.title = 'Complete your profile';
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.match.params.step !== nextProps.match.params.step) {
      const step = nextProps.match.params.step;  // eslint-disable-line
      const section = constants.STEP_SECTIONS[step];
      this.props.getSectionData(
        section,
        this.props.token,
        this.props[section],
        this.props.history,
        this.props.siteId,
      );
      window.scrollTo(0, 0);
    }
  }

  componentWillUnmount() {
    this.props.onUnmount();
  }

  getCardTitle = () => {
    return constants.COMPLETE_PROFILE_TITLES[this.props.match.params.step];
  }

  getForm = () => {
    switch (this.props.match.params.step) {
      case 'step-1':
        return (
          <AccountInfoForm
            inputs={this.props.basicinfo}
            hideBranchField={this.props.hideBranchField}
            inputChangedHandler={this.inputChangedHandler}
          />
        );
      case 'step-2':
        return (
          <PersonalInfoForm
            inputs={this.props.personalinfo}
            inputChangedHandler={this.inputChangedHandler}
            prevStep="step-1"
            redirectToStep={this.redirectToStep}
          />
        );
      case 'step-3':
        return (
          <LifestyleInfoForm
            inputs={this.props.lifestyleinfo}
            inputChangedHandler={this.inputChangedHandler}
            prevStep="step-2"
            redirectToStep={this.redirectToStep}
          />
        );
      case 'step-4':
        return (
          <EducationInfoForm
            inputs={this.props.educationinfo}
            inputChangedHandler={this.inputChangedHandler}
            prevStep="step-3"
            redirectToStep={this.redirectToStep}
          />
        );
      case 'step-5':
        return (
          <FamilyInfoForm
            inputs={this.props.familyinfo}
            inputChangedHandler={this.inputChangedHandler}
            prevStep="step-4"
            redirectToStep={this.redirectToStep}
          />
        );
      case 'step-6':
        return (
          <ContactInfoForm
            inputs={this.props.contactinfo}
            inputChangedHandler={this.inputChangedHandler}
            prevStep="step-5"
            redirectToStep={this.redirectToStep}
          />
        );
      case 'step-7':
        return (
          <ReferenceInfoForm
            inputs={this.props.referenceinfo}
            inputChangedHandler={this.inputChangedHandler}
            prevStep="step-6"
            redirectToStep={this.redirectToStep}
          />
        );
      case 'step-8':
        return (
          <FileUploadForm
            inputs={this.props.photos}
            inputChangedHandler={this.inputChangedHandler}
            files={this.props.files}
            deleteFile={fileID => this.deleteFile(fileID)}
            errors={this.props.errors}
            prevStep="step-7"
            nextStep="step-9"
            fileType="IMAGE"
            redirectToStep={this.redirectToStep}
          />
        );
      case 'step-9':
        return (
          <FileUploadForm
            inputs={this.props.pdfs}
            inputChangedHandler={this.inputChangedHandler}
            files={this.props.files}
            deleteFile={fileID => this.deleteFile(fileID)}
            errors={this.props.errors}
            prevStep="step-8"
            nextStep="status"
            redirectToStep={this.redirectToStep}
          />
        );
      default:
        return null;
    }
  }


  inputChangedHandler = (event, field) => {
    const step = this.props.match.params.step;  // eslint-disable-line
    const section = constants.STEP_SECTIONS[step];
    this.props.inputChangedHandler(
      event,
      field,
      section,
      this.props[section],
    );
  }

  submitHandler = (event) => {
    const step = this.props.match.params.step;  // eslint-disable-line
    const section = constants.STEP_SECTIONS[step];
    this.props.submitHandler(
      event,
      section,
      this.props[section],
      this.props.token,
      this.props.history,
      this.props.siteId,
    );
  }

  deleteFile = (fileID) => {
    this.props.deleteFile(fileID, this.props.token);
  }

  redirectToStep = (step) => {
    if (step === 'status') {
      this.props.history.push({
        pathname: formatRoute(routes.PROFILE_STATUS),  // eslint-disable-line
        // state: { step: step }  // eslint-disable-line
      });
    } else {
      this.props.history.push({
        pathname: formatRoute(routes.COMPLETE_PROFILE, { step: step }),  // eslint-disable-line
        // state: { step: step }  // eslint-disable-line
      });
    }
  }

  render() {
    if (this.props.user.is_complete) {
      return <Redirect to="/" />;
    }

    let errors = null;
    if (this.props.errors.length > 0) {
      errors = (
        <Alert type="danger">
          {this.props.errors}
        </Alert>
      );
    }

    const title = this.getCardTitle();

    let display = (
      <div align="center">
        <br /><br /><br />
        <CircularProgress align="center" size={50} />
        <br />
        <Typography variant="subheading">Please wait. This may take some time! <br /> Please do not refresh the page.</Typography>
      </div>
    );

    if (!this.props.loading && !this.props.user.is_complete) {
      display = (
        <Paper className={[classes.cardFancy, classes.padding15, classes.noBorderXS].join(' ')}>
          <Typography variant="headline" className={classes.regTitle}>{title}</Typography>
          <span className={classes.titleUnderline} />
          {errors}
          <form method="post" onSubmit={this.submitHandler} encType="multipart/form-data">
            {this.getForm()}
          </form>
          <br />
        </Paper>
      );
    }

    return (
      <MainLayout isAuthenticated onlyLogout>
        <Grid container justify="center">
          <Grid item md={8} sm={12} xs={12}>
            <div align="center">
              <Typography align="center" variant="headline">Complete your profile</Typography>
              <span className={classes.titleUnderline} />
            </div>
            {display}
          </Grid>
        </Grid>
        <FormErrorDialog open={this.props.hasError} handleClose={this.props.toggleError} />
      </MainLayout>
    );
  }
}


const mapStateToProps = (state) => {
  return {
    token: state.auth.token,
    user: state.auth.user,
    loading: state.profile.loading,
    hasError: state.profile.hasError,
    basicinfo: state.profile.basicinfo,
    personalinfo: state.profile.personalinfo,
    lifestyleinfo: state.profile.lifestyleinfo,
    educationinfo: state.profile.educationinfo,
    familyinfo: state.profile.familyinfo,
    contactinfo: state.profile.contactinfo,
    referenceinfo: state.profile.referenceinfo,
    photos: state.profile.photos,
    pdfs: state.profile.pdfs,
    files: state.profile.files,
    errors: state.profile.errors,
    siteId: state.common.site.id,
    hideBranchField: state.profile.hideBranchField,
  };
};


const mapDispatchToProps = (dispatch) => {
  return {
    getSectionData: (section, token, inputs, history, siteId) => dispatch(
      profileActions.getSectionData(section, token, inputs, history, siteId),
    ),
    toggleError: () => dispatch(profileActions.toggleError()),
    inputChangedHandler: (event, field, section, inputs) => dispatch(
      profileActions.inputChangedHandler(event, field, section, inputs),
    ),
    submitHandler: (event, section, inputs, token, history, siteId) => dispatch(
      profileActions.submitHandler(event, section, inputs, token, history, siteId),
    ),
    deleteFile: (fileID, token) => dispatch(profileActions.deleteFile(fileID, token)),
    onUnmount: () => dispatch(profileActions.onUnmount()),
  };
};


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CompleteProfile));



// WEBPACK FOOTER //
// ./src/profile/containers/CompleteProfile.js